import * as yup from 'yup';
import type { MessageDescriptor } from 'react-intl';

export const createPageTwoValidationSchema = (
  formatMessage: (descriptor: MessageDescriptor) => string,
  options: {
    shouldValidatePrivacyPolicy: boolean;
  }
) => {
  const { shouldValidatePrivacyPolicy } = options;

  const schema: Record<string, any> = {};

  if (shouldValidatePrivacyPolicy) {
    const privacyMessage = formatMessage({
      defaultMessage: 'Privacy policy should be accepted',
    });
    schema.privacy_policy_accepted = yup
      .boolean()
      .oneOf([true], privacyMessage)
      .required(privacyMessage);
  }

  schema.message = yup.string().strict();

  return yup.object().shape(schema);
};
